import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';
import 'gw-capability-quoteandbind-PremierLE-react';
import 'gw-capability-policychange-common-react';
import 'premier-capability-policychange-common-react';
import LEPolicyChangesPage from './pages/LEPolicyChanges/LEPolicyChangesPage';

setComponentMapOverrides(
    {
        PremierLEPolicyChangesPage: { component: 'PremierLEPolicyChangesPage' }
    },
    {
        PremierLEPolicyChangesPage: LEPolicyChangesPage
    }
);

export { default as PremierLEPolicyChangeWizard } from './PremierLEPolicyChangeWizard';
